import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryDown } from 'components/utils/breakpoint'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${rem(12)};
  margin: ${rem(8)} ${rem(-24)} ${rem(-8)};
  padding: ${rem(12)} ${rem(24)};
  border-top: 1px solid ${props => props.theme.palette.neutral.default.six};
  border-bottom: 1px solid ${props => props.theme.palette.neutral.default.six};

  &:empty {
    display: none;
  }

  ${mediaQueryDown.mobile} {
    margin: ${rem(8)} ${rem(-20)} ${rem(-16)};
    padding: ${rem(12)} ${rem(20)};
  }
`

interface Props {
  children: ReactNode
}

function OfferCalendarHeaderExtensionContainer(props: Props) {
  const { children } = props

  return <Container>{children}</Container>
}

export default OfferCalendarHeaderExtensionContainer
